import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Routes } from 'Utils';
import { RouteComponentProps, withRouter } from 'react-router';

interface HomeProps extends RouteComponentProps {
	history: any;
}
const useStyles = makeStyles({
	root: {
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
		alignItems: 'center',
		margin: '10rem auto',
		maxWidth: '50%',
	},
	card: {
		maxWidth: 345,
		background: 'rgb(127 214 221)',
		borderRadius: '5rem',
		border: 'none',
		color: 'white',
		fontSize: '14px',
		'&;hover': {
			background: 'red',
		},
	},
	media: {
		height: 140,
	},
});

const Home = ({ history }: HomeProps) => {
	const classes = useStyles();
	const goBack = () => {
		history.push(Routes.Login);
	};
	return (
		<Fragment>
			<div className={classes.root}>
				<h2>Welcome to Fledgling&apos;s Flight</h2>
				<button className={`${classes.card} px-5 py-1`} onClick={goBack}>
					Login
				</button>
			</div>
		</Fragment>
	);
};

export default withRouter(Home);
